(()=>{
 let imageSwapSequence=0;
 function swapProductImage(image,src,alt){
  if(!image||!src)return;
  const currentUrl=new URL(image.currentSrc||image.src,location.href),nextUrl=new URL(src,location.href);
  if(currentUrl.pathname===nextUrl.pathname){if(alt)image.alt=alt;return;}
  const swapId=String(++imageSwapSequence),preloader=new Image(),started=performance.now();
  image.dataset.imageSwapId=swapId;
  image.classList.add('is-image-loading');
  let settled=false;
  const finish=()=>{
   if(settled)return;
   settled=true;
   const commit=()=>{
    if(image.dataset.imageSwapId!==swapId)return;
    image.src=src;
    if(alt)image.alt=alt;
    image.removeAttribute('srcset');
    requestAnimationFrame(()=>requestAnimationFrame(()=>image.classList.remove('is-image-loading')));
   };
   setTimeout(commit,Math.max(0,160-(performance.now()-started)));
  };
  preloader.addEventListener('load',finish,{once:true});
  preloader.addEventListener('error',finish,{once:true});
  preloader.src=src;
  if(preloader.complete)finish();
 }
 function metalMediaGroup(label=''){
  const value=label.toLowerCase();
  if(value.includes('yellow gold'))return 'yellow';
  if(value.includes('rose gold'))return 'rose';
  return 'white';
 }
 function showMetalMedia(root,label){
  if(!root.hasAttribute('data-metal-media-gallery'))return;
  const group=metalMediaGroup(label),thumbnails=[...root.querySelectorAll('[data-image][data-media-group]')];
  thumbnails.forEach(thumbnail=>{thumbnail.hidden=thumbnail.dataset.mediaGroup!==group;thumbnail.setAttribute('aria-pressed','false');});
  const first=thumbnails.find(thumbnail=>thumbnail.dataset.mediaGroup===group&&thumbnail.dataset.mediaView==='front')||thumbnails.find(thumbnail=>thumbnail.dataset.mediaGroup===group);
  const image=root.querySelector('.product-main-image');
  if(first&&image){swapProductImage(image,first.dataset.image,first.dataset.imageAlt);first.setAttribute('aria-pressed','true');}
 }
 document.addEventListener('change',event=>{
  const el=event.target;
  if(el.matches('[data-sort]')){const url=new URL(location.href);url.searchParams.set('sort_by',el.value);url.searchParams.delete('page');location.assign(url);}
  if(el.matches('[data-variant-select]')){
   const root=el.closest('[data-product-root]'),opt=el.selectedOptions[0];
   root.querySelector('[data-price]').textContent=opt.dataset.price;
   const compare=root.querySelector('[data-compare]');if(compare){compare.hidden=opt.dataset.onSale!=='true';compare.textContent=opt.dataset.compare;}
   const button=root.querySelector('[data-add]');button.disabled=opt.dataset.available!=='true';button.textContent=button.disabled?'Sold out':(button.dataset.readyLabel||'Add to bag');
   const url=new URL(location.href);url.searchParams.set('variant',el.value);history.replaceState({},'',url);
   if(root.hasAttribute('data-metal-media-gallery'))showMetalMedia(root,opt.textContent);
   else if(opt.dataset.image){const image=root.querySelector('.product-main-image');swapProductImage(image,opt.dataset.image);root.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.image===opt.dataset.image)));}
  }
 });
 document.querySelectorAll('[data-metal-media-gallery] [data-variant-select]').forEach(select=>showMetalMedia(select.closest('[data-product-root]'),select.selectedOptions[0]?.textContent||''));
 document.addEventListener('click',event=>{
  const thumbnail=event.target.closest('[data-image]');if(thumbnail){const root=thumbnail.closest('[data-product-root]');const image=root.querySelector('.product-main-image');swapProductImage(image,thumbnail.dataset.image,thumbnail.dataset.imageAlt);root.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumbnail)));}
 });
 document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});}});
 document.addEventListener('toggle',event=>{
  const disclosure=event.target;
  if(!disclosure.matches('[data-header-disclosure]'))return;
  const summary=disclosure.querySelector(':scope > summary');
  if(summary)summary.setAttribute('aria-expanded',String(disclosure.open));
  if(disclosure.open){
   const header=disclosure.closest('[data-island-header]');
   header?.querySelectorAll('[data-header-disclosure][open]').forEach(other=>{if(other!==disclosure&&!disclosure.contains(other)&&!other.contains(disclosure))other.open=false;});
  }
 },true);
 document.addEventListener('click',event=>{
  const header=event.target.closest('[data-island-header]');
  if(header)return;
  document.querySelectorAll('[data-island-header] [data-header-disclosure][open]').forEach(disclosure=>{disclosure.open=false;});
 });
 const success=document.querySelector('.form-success');if(success){const detail=success.closest('details');if(detail)detail.open=true;success.focus();}
})();

// Delegation survives Shopify section reloads without registering duplicate handlers.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-motion-toggle]');
  if (!toggle) return;
  const section = toggle.closest('[data-marquee]');
  const paused = section.toggleAttribute('data-paused');
  toggle.setAttribute('aria-pressed', String(paused));
  toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(/^(Pause|Play)/, paused ? 'Play' : 'Pause'));
  toggle.querySelector('[data-motion-label]').textContent = paused ? 'Play' : 'Pause';
});
function enableMotionControls(scope = document) {
  scope.querySelectorAll('[data-motion-toggle]').forEach(button => { button.hidden = false; });
}
enableMotionControls();
document.addEventListener('shopify:section:load', event => enableMotionControls(event.target));

function enhanceHeroMotion(scope=document){
 scope.querySelectorAll('[data-hero-motion]').forEach(root=>{
  if(root.dataset.heroMotionReady)return;
  const video=root.querySelector('.hero-video'),toggle=root.querySelector('[data-hero-motion-toggle]');
  if(!video||!toggle)return;
  root.dataset.heroMotionReady='true';
  const reduceMotion=matchMedia('(prefers-reduced-motion:reduce)');
  if(reduceMotion.matches){video.pause();return;}
  toggle.hidden=false;
  const label=toggle.querySelector('[data-hero-motion-label]'),icon=toggle.querySelector('[data-hero-motion-icon]');
  const setReady=()=>root.setAttribute('data-video-ready','');
  if(video.readyState>=2)setReady();else video.addEventListener('canplay',setReady,{once:true});
  video.addEventListener('error',()=>{toggle.hidden=true;root.removeAttribute('data-video-ready');},{once:true});
  const sync=paused=>{
   root.toggleAttribute('data-hero-paused',paused);
   toggle.setAttribute('aria-pressed',String(paused));
   toggle.setAttribute('aria-label',paused?'Play hero film':'Pause hero film');
   label.textContent=paused?'Play film':'Pause film';
   icon.textContent=paused?'\u25b6':'\u2016';
  };
  toggle.addEventListener('click',()=>{
   const paused=!video.paused;
   if(paused)video.pause();else video.play().catch(()=>{});
   sync(paused);
  });
  if(matchMedia('(pointer:fine)').matches&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
   root.addEventListener('pointermove',event=>{
    const box=root.getBoundingClientRect();
    root.style.setProperty('--hero-x',`${((event.clientX-box.left)/box.width-.5)*-7}px`);
    root.style.setProperty('--hero-y',`${((event.clientY-box.top)/box.height-.5)*-5}px`);
   });
   root.addEventListener('pointerleave',()=>{root.style.setProperty('--hero-x','0px');root.style.setProperty('--hero-y','0px');});
  }
 });
}
enhanceHeroMotion();
document.addEventListener('shopify:section:load',event=>enhanceHeroMotion(event.target));

function enhanceProductOptions(scope=document){
 scope.querySelectorAll('[data-product-root]').forEach(root=>{
  if(root.dataset.optionsReady)return;
  const select=root.querySelector('[data-variant-select]'),data=root.querySelector('[data-variant-data]');
  if(!select||!data)return;
  const model=JSON.parse(data.textContent);if(!model.variants.length)return;
  const dropdowns=root.dataset.productOptionsStyle==='dropdowns';
  const box=document.createElement('div');box.className=`product-options${dropdowns?' product-options--dropdowns':''}`;
  let chosen=[...(model.variants.find(v=>String(v.id)===select.value)||model.variants[0]).options];
  model.options.forEach((name,index)=>{
   const values=[...new Set(model.variants.map(v=>v.options[index]))];
   if(dropdowns){
    const field=document.createElement('div'),label=document.createElement('label'),wrap=document.createElement('div'),control=document.createElement('select');
    const id=`ProductOption-${Math.random().toString(36).slice(2)}-${index}`;
    field.className='product-option-select';label.textContent=name;label.htmlFor=id;wrap.className='product-option-select__control';control.id=id;control.dataset.optionIndex=index;
    values.forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;control.append(option);});
    control.value=chosen[index];
    control.addEventListener('change',()=>{
     chosen[index]=control.value;
     let match=model.variants.find(v=>v.options.every((value,i)=>value===chosen[i]));
     if(!match)match=model.variants.find(v=>v.options[index]===control.value);
     if(match){chosen=[...match.options];select.value=String(match.id);select.dispatchEvent(new Event('change',{bubbles:true}));}
     sync();
    });
    wrap.append(control);field.append(label,wrap);box.append(field);
   }else{
    const field=document.createElement('fieldset'),legend=document.createElement('legend'),valueBox=document.createElement('div');
    legend.textContent=name;valueBox.className='option-values';field.append(legend,valueBox);
    values.forEach(value=>{
     const button=document.createElement('button');button.type='button';button.textContent=value;button.dataset.optionIndex=index;button.dataset.optionValue=value;
     button.addEventListener('click',()=>{
      chosen[index]=value;
      const match=model.variants.find(v=>v.options.every((x,i)=>x===chosen[i]));
      if(match){select.value=String(match.id);select.dispatchEvent(new Event('change',{bubbles:true}));}
      else{select.value='';root.querySelector('[data-add]').disabled=true;root.querySelector('[data-add]').textContent='Combination unavailable';root.querySelector('[data-price]').textContent='Choose an available combination';}
      sync();
     });valueBox.append(button);
    });box.append(field);
   }
  });
  function sync(){
   box.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(chosen[+b.dataset.optionIndex]===b.dataset.optionValue)));
   box.querySelectorAll('select').forEach(control=>{control.value=chosen[+control.dataset.optionIndex];});
  }
  select.closest('.variant-native').before(box);select.closest('.variant-native').hidden=true;
  select.addEventListener('change',()=>{const v=model.variants.find(v=>String(v.id)===select.value);if(v){chosen=[...v.options];sync();}});
  root.dataset.optionsReady='true';sync();
 });
}
enhanceProductOptions();
document.addEventListener('shopify:section:load',event=>enhanceProductOptions(event.target));

function normalizeWatchMedia(scope=document){
 scope.querySelectorAll('[data-normalize-watch-media] img').forEach(image=>{
  if(image.dataset.watchMediaReady)return;
  image.dataset.watchMediaReady='pending';
  const normalize=()=>{
   try{
    const sampleWidth=120;
    const sampleHeight=Math.max(1,Math.round(sampleWidth*image.naturalHeight/image.naturalWidth));
    const canvas=document.createElement('canvas');
    canvas.width=sampleWidth;canvas.height=sampleHeight;
    const context=canvas.getContext('2d',{willReadFrequently:true});
    context.drawImage(image,0,0,sampleWidth,sampleHeight);
    const pixels=context.getImageData(0,0,sampleWidth,sampleHeight).data;
    const rows=[];
    let maxSpan=0;
    const scanHeight=Math.floor(sampleHeight*.79);
    for(let y=0;y<scanHeight;y++){
     let first=-1,last=-1;
     for(let x=0;x<sampleWidth;x++){
      const offset=(y*sampleWidth+x)*4;
      const luminance=(pixels[offset]+pixels[offset+1]+pixels[offset+2])/3;
      if(luminance>30){if(first<0)first=x;last=x;}
     }
     const span=last-first;
     if(span>0){rows.push({y,first,last,span});maxSpan=Math.max(maxSpan,span);}
    }
    if(!maxSpan)throw new Error('Watch silhouette was not detected');
    const strongRows=rows.filter(row=>row.span>=maxSpan*.94);
    const centers=strongRows.map(row=>(row.first+row.last)/2).sort((a,b)=>a-b);
    const heights=strongRows.map(row=>row.y).sort((a,b)=>a-b);
    const median=values=>values[Math.floor(values.length/2)];
    const sourceCenterX=median(centers)/sampleWidth*image.naturalWidth;
    const sourceCenterY=median(heights)/sampleHeight*image.naturalHeight;
    const frame=image.parentElement.getBoundingClientRect();
    const fit=Math.max(frame.width/image.naturalWidth,frame.height/image.naturalHeight);
    const renderedWidth=image.naturalWidth*fit;
    const renderedHeight=image.naturalHeight*fit;
    const currentX=sourceCenterX*fit-(renderedWidth-frame.width)/2;
    const currentY=sourceCenterY*fit-(renderedHeight-frame.height)/2;
    const currentSpan=maxSpan/sampleWidth*renderedWidth;
    const scale=Math.min(1.35,Math.max(.82,frame.width*.62/currentSpan));
    const offsetX=frame.width/2-(frame.width/2+(currentX-frame.width/2)*scale);
    const offsetY=frame.height/2-(frame.height/2+(currentY-frame.height/2)*scale);
    image.style.setProperty('--watch-media-scale',scale.toFixed(4));
    image.style.setProperty('--watch-media-x',`${offsetX.toFixed(2)}px`);
    image.style.setProperty('--watch-media-y',`${offsetY.toFixed(2)}px`);
    image.dataset.watchMediaReady='true';
   }catch(error){
    image.dataset.watchMediaReady='fallback';
   }
  };
  if(image.complete&&image.naturalWidth)normalize();
  else image.addEventListener('load',normalize,{once:true});
 });
}
normalizeWatchMedia();
document.addEventListener('shopify:section:load',event=>normalizeWatchMedia(event.target));

document.addEventListener('submit',event=>{
 const form=event.target;if(!form.matches('.product-form')||form.hasAttribute('data-preview-form'))return;
 if(form.dataset.submitting){event.preventDefault();return;}
 form.dataset.submitting='true';const button=form.querySelector('[data-add]');
 // The variant and native Shopify form stay intact; Shopify owns cart validation and checkout.
 if(button){button.setAttribute('aria-disabled','true');button.textContent='Preparing your bag…';}
});
addEventListener('pageshow',()=>document.querySelectorAll('.product-form').forEach(form=>{delete form.dataset.submitting;const b=form.querySelector('[data-add]');if(b&&!b.disabled){b.removeAttribute('aria-disabled');b.textContent=b.dataset.readyLabel||'Add to bag';}}));
